import { render, staticRenderFns } from "./periodInfo.vue?vue&type=template&id=f5146cb8"
import script from "./periodInfo.vue?vue&type=script&lang=js"
export * from "./periodInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports